<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import Loader from "@/components/widgets/loader";
    
   export default {
      page: {
         title: "Businesses",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader, Loader },
      data() {
         return {
            title: "Businesses",
            items: [
               {
                  text: "Businesses",
                  active: true,
               },                   
            ],

            contacts: [],
            listing_length: 10,
            keyword: '',
            status: null,
            from: null,
            to: null,
            total: null,
            pagination: {},
            active_page_url: '',

            loading: false,

            token: '',
         };
      },
      mounted() {
         this.fetchContacts();
      },

      methods: {        

         fetchContacts(page_url = null) {
            this.getToken();
            let url = "/api/hub/contacts/index?type=3&keyword=" + this.keyword + "&limit=" + this.listing_length;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            
            this.loading = true;
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  //console.log(responseData);
                  this.contacts = responseData.contacts.data;
                  
                  this.pagination = responseData.contacts.links;
                  this.from = responseData.contacts.from;
                  this.to = responseData.contacts.to;
                  this.total = responseData.contacts.total;
               
               })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         getToken() {
            if (localStorage.getItem('vc_hub')) {
               var vc_hub =  JSON.parse(localStorage.getItem('vc_hub'));
               if(vc_hub.token) {
                  this.token = vc_hub.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },  

         setBackURL(contact_id, route) {
            //alert(this.active_page_url);
            localStorage.setItem('back_url', this.active_page_url);
            if(route == 'edit') {
               this.$router.push({ name: 'customers.edit', params: { id: contact_id} }); 

            } else if(route == 'vehicles') {
               this.$router.push({ name: 'customers.vehicles', params: { id: contact_id} }); 

            } else if(route == 'logs') {
               this.$router.push({ name: 'customers.logs', params: { id: contact_id} }); 

            } else if(route == 'followups') {
               this.$router.push({ name: 'customers.followups', params: { id: contact_id} }); 
            }
            
         },    

      }
   }
</script>
    
<template>
<Loader :loading="loading">
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchContacts()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchContacts()"/>
                           </label>
                        </div>                     
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>SI No.</th>
                              <th>Name</th>
                              <th>Contact</th>
                              <th>District, <br>State</th>
                              <th>Place, <br>Pincode</th>
                              <th>Source</th>
                              <th>Created On</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(contacts.length)">
                           <tr v-for="(contact, index) in contacts" :key="contact.id">
                              <td>{{index + 1}}</td>
                              <td>
                                 {{contact.name}}
                              </td>
                              <td class="no-wrap">{{contact.converted_mobile_number}}<br>{{contact.email}}</td>
                              <td>
                                 {{contact.district}}
                                 <span v-if="contact.district && contact.state">,</span><br>
                                 {{contact.state}}
                              </td>
                              <td>
                                 {{contact.place}}
                                 <span v-if="contact.pincode && contact.place">,</span> <br>{{contact.pincode}}
                              </td>
                              <td>{{contact.source}}</td>
                              <td class="no-wrap">{{contact.converted_created_at}}</td>
                              <td>
                                 <!-- <router-link :to="{ name: 'customers.edit', params: { id: contact.id }  }" class="btn btn-primary me-2 mb-2 btn-sm">Edit</router-link>                                  
                                 <router-link :to="{ name: 'customers.vehicles', params: { id: contact.id }  }" class="btn btn-primary me-2 mb-2 btn-sm">Vehicles</router-link>

                                 <router-link :to="{ name: 'customers.logs', params: { id: contact.id }  }" class="btn btn-primary me-2 mb-2 btn-sm">Logs</router-link>
                              
                                 <router-link :to="{ name: 'customers.followups', params: { id: contact.id }  }" class="btn btn-primary me-2 mb-2 btn-sm">Follow Ups</router-link> -->

                                 <a href="#" class="btn btn-primary me-2 mb-2 btn-sm" @click.prevent="setBackURL(contact.id, 'edit')">Edit</a>

                                 <a href="#" class="btn btn-primary me-2 mb-2 btn-sm" @click.prevent="setBackURL(contact.id, 'vehicles')">Vehicles</a>

                                 <a href="#" class="btn btn-primary me-2 mb-2 btn-sm" @click.prevent="setBackURL(contact.id, 'logs')">Logs</a>

                                 <a href="#" class="btn btn-primary me-2 mb-2 btn-sm" @click.prevent="setBackURL(contact.id, 'followups')">Follow Ups</a>
                                
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="8" class="text-center">No businesses found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->                  
                  <caption v-if="Boolean(contacts.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchContacts(page.url + '&type=3&limit='+ listing_length + '&keyword=' + keyword )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</Loader>
</template>
